export default {
  /*
   data: 数据源
   idKey: 主键标识符
   pidKey: 父级主键标识符
   parentNode: 父级节点
   return: 树形结构json对象
   */
  toTreeJson (option) {
    let result = []

    function recursion (data, idKey, pidKey, parentNode) {
      _.map(data, (node) => {
        if (!parentNode && !node[pidKey]) {
          node['children'] = []
          node.class = 1
          result.push(node)
          recursion(option.data, idKey, pidKey, node)
        } else if (parentNode && node[pidKey] === parentNode[idKey]) {
          if (!parentNode.hasOwnProperty('children')) {
            parentNode['children'] = []
          }
          node.class = parentNode.class + 1
          parentNode['children'].push(node)
          recursion(option.data, idKey, pidKey, node)
        }
      })
    }

    recursion(option.data, option.idKey, option.pidKey, null)
    return result
  },
  filterUsers: function filterUsers (stations, result, ignoreType) {
    ignoreType = ignoreType || ['公司']
    stations.forEach(item => {
      if (item.children && item.children.length) {
        // let hasStation = item.children.find(sitem => {
        //   // return sitem.organizationType === '收费站' || (sitem.children && sitem.children.length)
        //   return (sitem.organizationType.indexOf('公司') > -1)
        // })
        let hasStation = item.children && item.children.length
        let newItem = _.cloneDeep(item)
        if (hasStation) {
          newItem.children = []
        } else {
          newItem.children = undefined
        }
        if (result) {
          result.push(newItem)
        }
        filterUsers(item.children, newItem.children, ignoreType)
      } else {
        let newItem = _.cloneDeep(item)
        newItem.children = undefined
        if (result) {
          result.push(newItem)
        }
      }
    })
  },
  filterCompany: function filterCompany (stations, result, ignoreType) {
    ignoreType = ignoreType || ['公司']
    stations.forEach(item => {
      if (item.children && item.children.length) {
        let hasStation = item.children.find(sitem => {
          // return sitem.organizationType === '收费站' || (sitem.children && sitem.children.length)
          return (sitem.organizationType.indexOf('公司') > -1)
        })
        if (item.id !== '20180227144821_B37C228499B24134A2E938C942098681') {
          let newItem = _.cloneDeep(item)
          if (hasStation) {
            newItem.children = []
          } else {
            newItem.children = undefined
          }
          if (result) {
            result.push(newItem)
          }
          filterCompany(item.children, newItem.children, ignoreType)
        } else {
          filterCompany(item.children, result, ignoreType)
        }
      }
    })
  }
}
